import {
	defineBrandThemeDefinition,
	defineBrandThemePreset,
	defineThemeTokens,
} from './schema'
import type {
	BrandThemeDefinition,
	BrandThemePreset,
	ThemeTokenRecord,
} from './types'

export function createThemeTokens(tokens: ThemeTokenRecord): ThemeTokenRecord {
	return defineThemeTokens(tokens)
}

export function extendThemeTokens(
	base: ThemeTokenRecord,
	overrides: Partial<ThemeTokenRecord>,
): ThemeTokenRecord {
	return defineThemeTokens({
		...base,
		...overrides,
	})
}

export function createThemePreset(
	preset: BrandThemePreset,
): BrandThemePreset {
	return defineBrandThemePreset(preset)
}

export function createBrandThemeDefinition(
	definition: BrandThemeDefinition,
): BrandThemeDefinition {
	return defineBrandThemeDefinition(definition)
}
